import { useState, useRef, useEffect } from 'react'
import { reportUnexpectedError } from '../../../lib/reportError'

export function useCopyWithFeedback(value: string, duration = 2000) {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  function copy() {
    if (!value) return
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true)
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => setCopied(false), duration)
    }).catch(reportUnexpectedError)
  }

  return { copied, copy }
}
